<template>
  <div>
    <div class="flex md12">

      <vuestic-widget :headerText="$t('home.title')">

        <vuestic-data-table

          :apiUrl="apiUrl"
          :apiMode="apiMode"
          :http-options="httpOptions"
          :tableFields="tableFields"
          :itemsPerPage="itemsPerPage"
          :defaultPerPage="defaultTablePerPage"
          :sortFunctions="sortFunctions"
          clickable
          :queryParams="queryParams"
          :initialPage="initialPage"
          :dataProvider="dataProvider"
          @row-clicked="onRowClick"
          @vuetable:cell-clicked="onCellClicked"
          @vuestic:row-clicked="onRowClick"
        >
          Loading
        </vuestic-data-table>
      </vuestic-widget>

    </div>
    <div class="flex md12 align--center justify--center">
      <div class="pre-loader-container">
        <vuestic-pre-loader v-show="isShown"
                            class="pre-loader"></vuestic-pre-loader>
        <div v-if="!isShown">
          <button class="btn btn-primary" @click="addCards()">
            Show More
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuesticCard from '../../../vuestic-theme/vuestic-components/vuestic-card/VuesticCard'
import QueryParams from '../../../vuestic-theme/vuestic-components/vuestic-datatable/data/query-params'
import { transformCompaniesResponse } from '../common/transform'

export default {
  name: 'companies',
  components: { VuesticCard },
  data () {
    let tableFields = [
      {
        name: 'title',
        dataClass: 'text-left',
        title: this.$t('common.table.companyName'), // TODO localize
      },

      {
        name: 'unread',
        title: this.$t('common.table.unread'),
        dataClass: 'text-center',
        width: '20%'
      }
    ]
    return {
      apiUrl: null,
      tableData: { data: [] },
      apiMode: false,
      clickable: true,
      httpOptions: {
        headers: {
          Authorization: this.$http.defaults.headers.common.Authorization,
          'Content-Type': 'application/json'
        }
      },
      tableFields: tableFields,
      defaultTablePerPage: 6,
      initialPage: 1,
      itemsPerPage: [
        {
          value: 5,
        },
        {
          value: 6,
        },
        {
          value: 10,
        },
      ],
      sortFunctions: null,
      queryParams: QueryParams,

      isShown: false,
    }
  },
  methods: {

    dataProvider: async function (pagination) {
      return transformCompaniesResponse(pagination)
    },

    onCellClicked (data, field) {
      console.log('cellClicked: ', field.name)
      this.$refs.vuetable.toggleDetailRow(data.id)
    },

    onRowClick (row) {
      this.$router.push({ name: 'companyDetails', params: { companyId: row.id } })
    }
  },
}
</script>

<style lang="scss">
  $singleGutter: #{(19/16)}rem;

  .cards-container {
    display: flex;
    flex-wrap: wrap;
    margin: -$singleGutter;
    align-items: flex-start;

    .vuestic-card {
      margin: $singleGutter;

      width: calc(33% - #{$singleGutter} * 2);

      @include media-breakpoint-only(xl) {
        width: calc(25% - #{$singleGutter} * 2);
      }

      @include media-breakpoint-only(lg) {
        width: calc(33.3% - #{$singleGutter} * 2);
      }

      @include media-breakpoint-only(sm) {
        width: calc(50% - #{$singleGutter} * 2);
      }

      @include media-breakpoint-only(xs) {
        width: calc(100% - #{$singleGutter} * 2);
      }
    }
  }

  .pre-loader-container {
    height: 50px;
    margin-top: 50px;
    margin-bottom: 50px;
  }
</style>
